import {
  EdgeProps,
  getBezierPath,
  getStraightPath,
} from "@xyflow/react";
import { useStore } from "../App/store";
import { useState, memo } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

function EdgeItem(props: EdgeProps) {
  const { id, sourceX, sourceY, targetX, targetY, label } = props;
  const [showDialog, setShowDialog] = useState(false);
  const [labelInput, setLabelInput] = useState("");
  const user = useStore((state) => state.user);
  const edgeType = user?.settings?.edgeType || "bezier"; // Get user preference, default to bezier

  const [edgePath] =
    edgeType === "straight"
      ? getStraightPath({
          sourceX,
          sourceY,
          targetX,
          targetY,
        })
      : getBezierPath({
          sourceX,
          sourceY,
          targetX,
          targetY,
        });

  const handleDoubleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    setLabelInput((label as string) || "");
    setShowDialog(true);
  };

  const handleSaveLabel = () => {
    if (labelInput.trim()) {
      useStore.getState().setEdgeLabel(id, labelInput);
    }
    setShowDialog(false);
  };

  const labelX = (sourceX + targetX) / 2;
  const labelY = (sourceY + targetY) / 2;
  return (
    <>
      <g
        className={`react-flow__edge${props.selected ? " selected" : ""}`}
        onDoubleClick={handleDoubleClick}
      >
        <path
          id={id}
          d={edgePath}
          className="react-flow__edge-path"
          style={props.style}
          markerEnd={props.markerEnd}
        />
        {label && (
          <text
            x={labelX}
            y={labelY}
            style={{
              fontSize: 10,
              fill: "var(--focusmap-text-muted)",
              textAnchor: "middle",
            }}
          >
            {label}
          </text>
        )}
      </g>
      <Dialog
        header="Enter Edge Label"
        visible={showDialog}
        style={{ width: "400px" }}
        onHide={() => setShowDialog(false)}
        footer={
          <div>
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={() => setShowDialog(false)}
              className="p-button-text"
            />
            <Button
              label="Save"
              icon="pi pi-check"
              onClick={handleSaveLabel}
              autoFocus
            />
          </div>
        }
      >
        <div className="p-fluid">
          <InputText
            style={{ width: "95%" }}
            value={labelInput}
            onChange={(e) => setLabelInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSaveLabel()}
            placeholder="Enter label text"
            autoFocus
          />
        </div>
      </Dialog>
    </>
  );
}

export default memo(EdgeItem);
